var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"outlined":"","small":_vm.small},on:{"click":_vm.changeLang}},[_vm._v(_vm._s(_vm.$t(_vm.lang)))])}
var staticRenderFns = []

export { render, staticRenderFns }